@use "styles/mixins/_rem.scss" as rem;

.image-preview-shell {
  position: absolute;
  width: rem.torem(92px);
  top: rem.torem(50px);
}

.image-preview-blur-offer-preview {
  background-color: var(--color-background-default);
  filter: blur(2px);
  position: absolute;
  top: rem.torem(1px);
  width: 92px;
  overflow: hidden;
}

.image-preview-offer-preview {
  background-color: var(--color-background-default);
  border-radius: var(--size-border-radius-s);
  left: rem.torem(16.16px);
  position: absolute;
  top: rem.torem(22.4px);
  height: rem.torem(93.2px);
}
